
export default class NewsletterPopup {
  constructor () {
    this.button = document.querySelector('[data-role="popup-open"]')
    this.icon = document.querySelector(this.button.dataset.ico)
    this.target = this.button.dataset.target
    this.el = document.querySelector(this.target)

    this.options = {
      open: this.button.dataset.open,
      close: this.button.dataset.close
    }

    this.button.addEventListener('click', () => {
      this.el.className.indexOf('open') > -1
        ? this.close()
        : this.open()
    })
  }

  open () {
    this.el.className = `${this.target} open`.replace('.', '')
    this.icon.className = `icon ${this.options.close}`
  }

  close () {
    this.el.className = this.target.replace('.', '')
    this.icon.className = `icon ${this.options.open}`
  }
}
